const DRAFT_EDITOR_PROPS = [
  "autoCapitalize",
  "autoComplete",
  "autoCorrect",
  "spellCheck",
  "stripPastedStyles",
  "handleBeforeInput",
  "handlePastedText",
  "handleReturn",
  "tabIndex"
];

export { DRAFT_EDITOR_PROPS };
//# sourceMappingURL=consts.js.map
